import { render, staticRenderFns } from "./UnitPackagingCost.vue?vue&type=template&id=5b515739&scoped=true"
import script from "./UnitPackagingCost.vue?vue&type=script&lang=ts"
export * from "./UnitPackagingCost.vue?vue&type=script&lang=ts"
import style0 from "./UnitPackagingCost.vue?vue&type=style&index=0&id=5b515739&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b515739",
  null
  
)

export default component.exports